import { BaseIcon, BaseIconProps } from '../BaseIcon';

export type ChevronUpIconProps = Omit<BaseIconProps, 'children'>;

export const ChevronUpIcon = ({ ...props }: ChevronUpIconProps) => (
  <BaseIcon width="11" height="8" viewBox="0 0 11 8" fill="none" {...props}>
    <path d="M10.669 7.2433C10.2584 7.61276 9.62616 7.57948 9.2567 7.16897L5.49999 2.99485L1.74329 7.16897C1.37383 7.57948 0.741537 7.61276 0.331027 7.2433C-0.079483 6.87384 -0.112761 6.24155 0.256698 5.83104L4.7567 0.831042C4.94634 0.620328 5.21651 0.500007 5.49999 0.500007C5.78348 0.500007 6.05364 0.620328 6.24329 0.831042L10.7433 5.83104C11.1127 6.24155 11.0795 6.87384 10.669 7.2433Z" />
  </BaseIcon>
);

ChevronUpIcon.displayName = 'ChevronUpIcon';
